import { Badge } from "@/components/ui/badge";
import {
  buildKindOf,
  platformLabel,
  sequenceText,
  type JobBuildFields,
} from "@/lib/buildLabels";

/** Which build of a publish run a job is: "#3/5 final (PGO)" with the
 *  platform/libc next to it. Renders nothing for an ordinary (customer) job
 *  whose columns say nothing about a build. `total` is the number of builds
 *  known for the job's run (the detail page loads the siblings). */
export function BuildBadge({
  job,
  total,
  showPlatform = true,
}: {
  job: JobBuildFields;
  total?: number;
  showPlatform?: boolean;
}) {
  const info = buildKindOf(job);
  if (!info) return null;
  const seq = sequenceText(job.build_seq, total);
  const title = info.derived
    ? `${info.label} (derived from the job's own fields; this job was submitted without a build label)`
    : `${info.label}${job.build_run ? ` — run ${job.build_run}` : ""}`;
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      <Badge variant="info" title={title} className="cursor-help">
        {seq ? `#${seq} ` : ""}
        {info.label}
      </Badge>
      {showPlatform && (
        <Badge variant="outline" className="font-mono font-normal">
          {platformLabel(job)}
        </Badge>
      )}
    </span>
  );
}
